/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.publicALaCarteProducts

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.publicALaCarteProducts.PublicAlaCarteProductsApi
import features.publicALaCarteProducts.models.PublicALaCarteProductsModel
import features.publicALaCarteProducts.serializePublicAlaCarteProductsState



/**
 * Get public A la carte products list [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("PublicAlaCarteProductsApi")
class PublicAlaCarteProductsApiJs {

    /**
     * Get public A la carte products list
     */
    fun getPublicAlaCarteProducts(
        overrideHeaders: String?, 

    ): Promise<String?>  {
        return GlobalScope.promise {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

            val result = PublicAlaCarteProductsApi().getPublicAlaCarteProducts(
            overrideHeaders = decodedOverrideHeaders,
            
        ).toJsonResult<PublicALaCarteProductsModel>()
        
        
            return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    

    fun observePublicAlaCarteProductsState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        PublicAlaCarteProductsApi().publicAlaCarteProductsState.serializePublicAlaCarteProductsState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
